import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import cn from 'classnames';
import DeleteIcon from 'svg/delete.svg';
const DeleteButton = ({ entity, isDisabled = false, onDelete })=>{
    const onClick = ()=>!isDisabled && onDelete(entity);
    return /*#__PURE__*/ _jsx(DeleteIcon, {
        className: cn('dataTable__deleteIcon', {
            'dataTable__deleteIcon--inactive': isDisabled
        }),
        onClick: onClick
    });
};
export default DeleteButton;
